<ng-template #itemTemplate
             let-item="item">
  <div class="items">
    <span class="timeline-title">
      {{isPreviewEnabled && item.title?.length > 100 ? item.title.substring(0, 100) : item.title}}
      <rappider-button *ngIf="isPreviewEnabled && item.title.length > 100"
                       text="Show More"
                       (click)="openModal()"></rappider-button>
      <rappider-modal *ngIf="isPreviewEnabled"
                      [visible]="modalVisibility"
                      [title]="modalTitle"
                      cancelText="Close"
                      [okText]="null"
                      width="60%"
                      (cancelClick)="closeModal()">
        <div style="height:var(--height-12x)">
          <rappider-monaco-code-editor [ngModel]="item.title"
                                       [options]="editorOptions"
                                       [autoFormat]="true"
                                       [borderSettings]="{border: 'none'}"></rappider-monaco-code-editor>
        </div>
      </rappider-modal>
    </span>
    <span class="timeline-subtitle">
      {{item.subtitle}}
    </span>
    <p class="timeline-paragraph">
      {{item.paragraph}}
    </p>
    <div class="timeline-markdown-container"
         *ngIf="item.markdownContent">
      <rappider-markdown-viewer [customMarkdownClass]="'no-padding'"
                                [typeInRealTime]="item.markdownContent?.typeInRealTime"
                                [typingSpeed]="item.markdownContent?.typingSpeed ?? 1"
                                [markdownText]="item.markdownContent.markdownText"></rappider-markdown-viewer>
    </div>
    <div *ngIf="item.date"
         class="date-area"
         nz-row>
      <div nz-col>
        <i class="date-icon"
           nzType="clock-circle-o"
           nz-icon></i>
      </div>
      <div nz-col>
        <span>
          {{item.date | formatDate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<div class="timeline">
  <nz-timeline [nzReverse]="reverseTreeItem">
    <ng-container *ngIf="isTimelineItemsHasIcon; else iconlessTmpl">
      <nz-timeline-item *ngFor="let item of items"
                        [nzDot]="iconTemplate">
        <ng-container *ngTemplateOutlet="itemTemplate;context:{item}">
        </ng-container>
        <ng-template #iconTemplate>
          <ng-container *ngIf="item.icon && item.icon?.name">
            <rappider-icon class="dot-icon"
                           [color]="item.icon.color"
                           [theme]="item.icon.theme"
                           [name]="item.icon.name"
                           [type]="item.icon.type"
                           [size]="item.icon.size">
            </rappider-icon>
          </ng-container>
        </ng-template>
      </nz-timeline-item>

    </ng-container>
    <ng-template #iconlessTmpl>
      <nz-timeline-item *ngFor="let item of items"
                        [nzColor]="item.color">
        <ng-container *ngTemplateOutlet="itemTemplate;context:{item}">
        </ng-container>
      </nz-timeline-item>
    </ng-template>

  </nz-timeline>
</div>
